// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"9ab1e6e5","435":"d44026ff","633":"a06554d3","784":"c7d8e77d","820":"61b2b8de","952":"b94ff388"}[chunkId] + ".chunk.js";
};